import { Link } from '@solidjs/meta';

export function ExpletusSans()
{
	return (<>
		<Link rel='preconnect' href='https://fonts.googleapis.com' />
		<Link rel='preconnect' href='https://fonts.gstatic.com' crossorigin='' />
		<Link href='https://fonts.googleapis.com/css2?family=Expletus+Sans:ital,wght@0,400..700;1,400..700&display=swap' rel='stylesheet' />
	</>);
}
